import React, { useState } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";

import "./rsvp-modal.m.css";
import CloseIcon from "../../atoms/CloseIcon";

export const RsvpModal = ({ isOpen, onClose, sessionForum = "IMA CEO forum", story }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const subscriberMetadata = useSelector((state) => get(state, ["subscriberMetadata"], null));

  // Get client manager details
  const clientManagerEmail = get(subscriberMetadata, ["client-manager-email"], "");
  const clientManagerName = get(subscriberMetadata, ["client-manager"], "");
  const clientManagerPhone = get(subscriberMetadata, ["client-manager-mobile"], "");

  // Handle body scroll lock
  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.body.classList.add('modal-open');

      const preventKeyboardScroll = (e) => {
        const modalContent = document.querySelector('[data-modal-content]');
        if (modalContent && !modalContent.contains(e.target)) {
          const scrollKeys = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '];
          if (scrollKeys.includes(e.key)) {
            e.preventDefault();
          }
        }
      };

      document.addEventListener('keydown', preventKeyboardScroll);

      return () => {
        document.removeEventListener('keydown', preventKeyboardScroll);
      };
    } else {
      document.body.style.overflow = '';
      document.body.classList.remove('modal-open');
    }
  }, [isOpen]);

  // Global cleanup effect
  React.useEffect(() => {
    return () => {
      document.body.style.overflow = '';
      document.body.classList.remove('modal-open');
    };
  }, []);

  const handleConfirmRsvp = async () => {
    setIsSubmitting(true);

    try {
      // Create the RSVP email data
      const requestData = {
        eventName: story?.headline || "Event Session",
        eventUrl: story?.url || window.location.href,
        sessionForum,
        clientManagerEmail,
        memberData: {
          email: get(subscriberMetadata, 'email', ''),
          name: get(subscriberMetadata, 'name', '') ||
                `${get(subscriberMetadata, 'first-name', '')} ${get(subscriberMetadata, 'last-name', '')}`.trim(),
          phone: get(subscriberMetadata, 'phone', ''),
          company: get(subscriberMetadata, 'organisation', ''),
        }
      };

      const response = await fetch("/rsvp-confirmation-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        setIsSuccess(true);
      } else {
        throw new Error('Failed to send RSVP confirmation');
      }
    } catch (error) {
      console.error("Error sending RSVP:", error);
      alert("Sorry, there was an error processing your RSVP. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    if (!isSubmitting) {
      setIsSuccess(false);
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div styleName="modal-overlay" onClick={handleClose}>
      <div
        styleName="modal-content"
        onClick={(e) => e.stopPropagation()}
        data-modal-content
      >
        <button styleName="close-button" onClick={handleClose} disabled={isSubmitting}>
          <CloseIcon strokeWidth="1.25" />
        </button>

        {!isSuccess ? (
          // Initial RSVP Modal
          <div styleName="rsvp-container">
            <div styleName="rsvp-title">
              <p>
                This session is exclusive to <span styleName="forum-highlight">{sessionForum}</span> members, RSVP to book a seat.
              </p>
            </div>

            <button
              styleName="confirm-button"
              onClick={handleConfirmRsvp}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Processing..." : "Confirm RSVP"}
            </button>

            <div styleName="manager-info-container">
              <div styleName="manager-info-text">
                <p>If you are a {sessionForum} member from a different city, please connect with your dedicated relationship manager</p>
              </div>
              <div styleName="manager-details">
                <span styleName="manager-name">{clientManagerName}</span>
                <span styleName="manager-email">{clientManagerEmail || "anamika_chakraborty@ima-india.com"}</span>
                <span styleName="manager-phone">{clientManagerPhone}</span>
              </div>
            </div>
          </div>
        ) : (
          // Success Modal
          <div styleName="success-container">
            <div styleName="success-title">
              <p>RSVP confirmed</p>
            </div>

            <div styleName="manager-info-container">
              <div styleName="manager-info-text">
                <p>*For any queries, reach out to your dedicated Client Manager</p>
              </div>
              <div styleName="manager-details">
                <span styleName="manager-name">{clientManagerName}</span>
                <span styleName="manager-email">{clientManagerEmail || "anamika_chakraborty@ima-india.com"}</span>
                <span styleName="manager-phone">{clientManagerPhone}</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};